import type { ReactElement } from 'react';
import React from 'react';
import { Paragraph } from '@axiom/ui';

export type AdminModalDetailProps = {
  emptyText: string;
  emptyName: string;
  children: ReactElement | null;
};

export const AdminModalDetail = ({
  emptyText,
  emptyName,
  children,
}: AdminModalDetailProps) => {
  return children || <Paragraph name={emptyName}>{emptyText}</Paragraph>;
};
